/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import {render} from '@canvas/react'
import {Provider} from 'react-redux'
import ready from '@instructure/ready'

import App from './react/app'
import createStore from './react/shared/create_store'

const CoursePage = () => (
  <Provider store={createStore()}>
    <App />
  </Provider>
)

ready(() => {
  const container = document.getElementById('course_paces')
  if (!container) {
    throw new Error('Failed to find the root element')
  }
  render(<CoursePage />, container)
})
